export const whitelabelConfig = {
  short: 'vivo',
  assetUrl: '/whitelabel/vivo/',
  iconUrl: '/img/icons/vivo/',
  storeName: 'Vivo',
  company: 'we-are.travel GmbH',
  analyticsId: 'G-E6KB8Z11ZC', //ga4
  analyticsType: 'gtag', //should be 'gtag', 'ua' or 'both'
  logoHeader:
    'https://assets.urlaubsgutschein.kaufen/whitelabel/vivo/vivo-logo.svg',
  logoFooter:
    'https://assets.urlaubsgutschein.kaufen/whitelabel/vivo/vivo-logo-white.svg',
  isStandalone: true,
  showHeader: true,
  showHeaderLogo: true,
  showFooterLogo: true,
  fixedNavbar: true,
  heroTitle:
    '<span class="has-background-primary hero-title-accent">Ihr Kurzurlaub</span> <span class="hero-title-subaccent">clever & günstig</span>',
  hasHeroSubtitle: true,
  heroSubtitle: 'Sparen Sie bis zu 70% mit Urlaubsgutscheinen',
  supportMail: 'info@we-are.travel',
  supportPhone: '+43 732 60 05 36',
  hasHeroAddition: false,
  showPromoNotification: false,
  showReduction: true,
  hasCookieConsent: true,
  hasNewsletterOptin: false,
  campaignsEnabled: true,
  heroImageResolution: {
    xl: {width: 2560, height: 500, crop: 'smart'},
    l: {width: 1200, height: 500, crop: 'smart'},
    m: {width: 1024, height: 500, crop: 'smart'},
    s: {width: 960, height: 300, crop: 'east'},
    xs: {width: 700, height: 200, crop: 'centre'},
  },
  hasOfferCta: true,
  hide5sup: true,
  // heroInfoText: 'Sparen Sie bis zu 70% für Ihren Kurzurlaub.',
  heroPoweredBy: true,
  homepage: {
    advantages: false,
  },
  styleOverride: () =>
    import(
      /* webpackPrefetch: true */

      /* webpackPreload: true */ '@/styles/styles-vivo.scss'
    ),
}
